import { render, staticRenderFns } from "./NewsOffersQuickButtons.vue?vue&type=template&id=4055a853&"
import script from "./NewsOffersQuickButtons.vue?vue&type=script&lang=js&"
export * from "./NewsOffersQuickButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4055a853')) {
      api.createRecord('4055a853', component.options)
    } else {
      api.reload('4055a853', component.options)
    }
    module.hot.accept("./NewsOffersQuickButtons.vue?vue&type=template&id=4055a853&", function () {
      api.rerender('4055a853', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/common/dashboard/panels/sitecontent/NewsOffersQuickButtons.vue"
export default component.exports